document.addEventListener('DOMContentLoaded', () => {
    const headerMenu = document.querySelector('.header-menu');
    const menuItems = document.querySelectorAll('.header-menu > li');
    const subMenus = document.querySelectorAll('.header-menu > li .sub-menu');

    let hasHovered = false;

    menuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
            const wrapper = item.querySelector('.header-menu .sub-menu-wrapper');

            if (!hasHovered) {
                subMenus.forEach(submenu => {
                    submenu.classList.remove('opacity-0', 'invisible');
                });
                hasHovered = true;
            }

            if (wrapper) {
                wrapper.classList.remove('hidden');
            }
        });

        item.addEventListener('mouseleave', () => {
            const wrapper = item.querySelector('.header-menu .sub-menu-wrapper');
            if (wrapper) {
                wrapper.classList.add('hidden');
            }
        });
    });

    if (headerMenu) {
        headerMenu.addEventListener('mouseleave', () => {
            subMenus.forEach(submenu => {
                submenu.classList.add('opacity-0', 'invisible');
            });
            hasHovered = false;
        });
    }
});

//# sourceMappingURL=header-navigation.js.map
